import utils from 'utils';

import {SidePanelList, SidePanelControls, UiMessage} from '@components/export';
import {useLabel} from '@/hooks/export';

export const SidePanel = (props: {
    mode: 'product' | 'order',
    itemList: apiOrder[] | apiProduct[],
    currentIndex: number | null,
    currentDate: Date,
    showDate: boolean,
    searchQuery: string,
    flags: {[name: string]: boolean}
    loading?: boolean,

    onHideDone: (value: boolean) => void,
    onShowPrevious: (value: boolean) => void,
    onItemClick: (index: number) => void,
    onDateChange: (date: Date) => void,
    onSearch: (query: string) => void,
}) => {
    const label = useLabel();

    return <>
        <div className={cmpClass}>
            <SidePanelControls
                loading={props.loading}
                mode={props.mode}
                currentDate={props.currentDate}
                itemList={props.itemList}
                flags={props.flags}
                searchQuery={props.searchQuery}

                onDateChange={(date) => props.onDateChange(date)}
                onHideDone={(checked) => props.onHideDone(checked)}
                onShowPrevious={(checked) => props.onShowPrevious(checked)}
                onSearch={(query) => props.onSearch(query)}
            />
            <div className={classMap.list}>
                {
                    props.loading && props.currentIndex === null ?
                        <UiMessage type={'loading'} text={label.loading} /> :
                        !props.itemList.length ?
                            <UiMessage type={'info'} text={label.noDataForDay} /> :
                            <SidePanelList
                                loading={props.loading}
                                mode={props.mode}
                                itemList={props.itemList}
                                currentIndex={props.currentIndex}
                                flags={props.flags}
                                showAll={!!props.searchQuery}

                                onItemClick={(index) => !props.loading ? props.onItemClick(index) : ''}
                            />
                }
            </div>
        </div>
    </>;
};

const cmpClass = 'side-panel';

const classMap = utils.generateClassMap(cmpClass, {
    list: 'list',
});
